import { Block } from '../../models/block';

class EmptyBlock extends Block {
    constructor({ columnStart = 0, columnLength = 1, merge = false }) {
        super({ columnStart, columnLength, merge });
    }
    getStyles = () => ({
        ...this.styles,
    });
}

export default EmptyBlock;
